module.exports = __webpack_public_path__ + "img/img-70.f5b02760.png";